import {useCallback, useEffect, useState} from 'react'
import {useAppDispatch, useAppSelector} from 'src/redux/storeHooks'
import {getSalesByChannelAsync} from 'src/redux/actions/authActions'
import {NormalizedSalesRow, parseSalesByChannel} from '../utils/parseDashboardReportResponse'
import {DashboardPeriodFilter} from '../utils/dashboardPeriodUtils'

export const useSalesByChannel = (period: DashboardPeriodFilter) => {
  const dispatch = useAppDispatch()
  const {fetchedUserAccountData, fetchedUserAccountLoading} = useAppSelector(
    (state) => state.userAccountData
  )
  const [rows, setRows] = useState<NormalizedSalesRow[]>([])
  const [loading, setLoading] = useState(false)

  const fetchSales = useCallback(async () => {
    if (fetchedUserAccountLoading || !fetchedUserAccountData?.id) return

    setLoading(true)

    try {
      const res = await dispatch(
        getSalesByChannelAsync({
          user_id: fetchedUserAccountData.id,
          filter_type: period,
        })
      )

      if (res.payload?.status_code === 200) {
        setRows(parseSalesByChannel(res.payload?.data || {}))
        return
      }

      setRows([])
    } catch {
      setRows([])
    } finally {
      setLoading(false)
    }
  }, [dispatch, fetchedUserAccountData?.id, fetchedUserAccountLoading, period])

  useEffect(() => {
    fetchSales()
  }, [fetchSales])

  return {rows, loading}
}
